import React from "react";
import ForgotMail from "./ForgotMail";
import ForgotIllustration from "./ForgotIllustration";

const ForgotMailPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row" id="forgot-mail-page-container">
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12 py-12 lg:py-0" id="forgot-mail-page-content-container">
        <ForgotMail />
      </div>

      <div className="hidden lg:flex lg:w-1/2 bg-[#E8F0FF] items-center justify-center" id="forgot-mail-page-illustration-container">
        <ForgotIllustration />
      </div>
    </div>
  );
};

export default ForgotMailPage;
